import PropTypes from 'prop-types';
import { Typography, Box, TextField, Grid } from '@mui/material';
import EmailInput from './EmailInput';

FormTextWithValue.propTypes = {
  value: PropTypes.object,
  title: PropTypes.any,
  name: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  flex: PropTypes.number,
  required: PropTypes.bool,
  autoComplete: PropTypes.oneOf(['off', 'no-autocomplete']),
  id: PropTypes.string,
};

export default function FormTextWithValue({
  value,
  title,
  name,
  setValue,
  disabled,
  flex,
  size = 'small',
  required = false,
  autoComplete = 'off',
  id = undefined
}) {
  return (
    <>
      <Grid item xs={flex}>
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          {typeof title === 'string' && title.toLowerCase().includes('email') ?
            <EmailInput
              value={value[name]}
              setValue={(val) => {
                setValue({ ...value, [name]: val })
              }}
              disabled={disabled}
              autoComplete={autoComplete}
              id={id}
            /> :
            <TextField
              error={required ? !value[name] : false}
              size={size}
              fullWidth
              name={name}
              disabled={disabled}
              value={value[name]}
              autoComplete={autoComplete}
              {...(id ? { id } : {})}
              onChange={(e) =>
                setValue({
                  ...value,
                  [name]: e.target.value,
                })
              }
          />}
        </Box>
      </Grid>
    </>
  );
}
